import React from "react";
import {ArrowBack, Close} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";


const BackButton = (props: any) => {
    const {url} = props;
    const navigate = useNavigate();

    const handleBack = () => {
       !url ? navigate(-1) : navigate(url);
    }

    return (
        <ArrowBack style={{marginRight: "1rem", fontWeight: "bold", cursor: "pointer"}}
                   onClick={handleBack}
                   color="secondary"/>
    );
};

export default BackButton;
